import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';

export const PrivateRoutes = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [mounted, setMounted] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Access localStorage only on client side
    if (typeof window !== 'undefined') {
      setMounted(true);
      const storedUser = localStorage.getItem('REACT_USER_AUTH');
      setUser(storedUser ? JSON.parse(storedUser) : null);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!isLoading && !user && typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('OpenLoginForm', {
          detail: { noRegiter: true, redirect: location.pathname },
        })
      );
    }
  }, [user, location, isLoading]);

  // Show nothing while checking localStorage
  if (isLoading) {
    return null;
  }

  return user ? (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  ) : (
    mounted ? <Navigate to='/' replace={true} /> : null
  );
};
